import {useContext, useEffect, useState} from 'react'

import PropTypes from 'prop-types'

import {atomIconSizes} from '@s-ui/react-atom-icon'
import AtomInput, {inputTypes} from '@s-ui/react-atom-input'
import Context from '@s-ui/react-context'
import useDebounce from '@s-ui/react-hooks/lib/useDebounce/index.js'
import VisuallyHidden from '@s-ui/react-primitive-visually-hidden'
import IconSearch from '@adv-mt/mt-svg-icons/lib/Search'

import {
  BASE_ELEMENTS_TYPES,
  INPUT_SEARCH_DEBOUNCE,
  INPUT_SEARCH_FILTER_ID,
  SEARCH_BAR_CLASS_NAME
} from '../../config.js'

const FilterWrapperBasicSearchBar = ({onSearch}) => {
  const [inputSearch, setInputSearch] = useState('')

  const {i18n} = useContext(Context)

  const debouncedTypedWord = useDebounce(inputSearch, INPUT_SEARCH_DEBOUNCE)

  const handleChangeSearch = e => {
    const {value} = e.target
    setInputSearch(value)
  }

  useEffect(() => {
    onSearch(debouncedTypedWord)
  }, [debouncedTypedWord, onSearch])

  return (
    <div className={SEARCH_BAR_CLASS_NAME}>
      <VisuallyHidden as={BASE_ELEMENTS_TYPES.LABEL} htmlFor={INPUT_SEARCH_FILTER_ID}>
        {i18n.t('FILTERS.INPUT_SEARCH.LABEL')}
      </VisuallyHidden>
      <AtomInput
        autocomplete="off"
        autoFocus
        id={INPUT_SEARCH_FILTER_ID}
        leftIcon={<IconSearch size={atomIconSizes.medium} />}
        onChange={handleChangeSearch}
        type={inputTypes.SEARCH}
        value={inputSearch}
      />
    </div>
  )
}

FilterWrapperBasicSearchBar.displayName = 'FilterWrapperBasicSearchBar'
FilterWrapperBasicSearchBar.propTypes = {
  onSearch: PropTypes.func
}

export default FilterWrapperBasicSearchBar
